import React from "react";
import Hero from "../../modules/HomeModule/Hero/Hero";
import Table from "../../components/table/Table";

function HomePage() {
  return (
    <>
      <Hero />
      <Table />
    </>
  );
}

export default HomePage;
